import React from 'react';
import moment from 'moment';
import 'moment/locale/pt';
import CustomizedTables from '../../../../components/Table';

export default function CprHistoryViewer({ cpr_history }) {
  
  const COLUMNSTABLE = [
    {
      headerName: 'Status',
      type: 'default',
      value: {
        first: {
          value: 'status',
        }
      }
    },
    {
      headerName: 'Valor investido',
      type: 'money',
      value: {
        first: {
          value: 'amount_cpr',
        }
      }
    },
    {
      headerName: 'Taxa',
      type: 'default',
      value: {
        first: {
          value: 'rate_cpr',
        }
      }
    },
    {
      headerName: 'Tipo',
      type: 'default',
      value: {
        first: {
          value: 'type',
        }
      }
    },
    {
      headerName: 'Data de geração',
      type: 'date',
      value: {
        first: {
          value: 'date_start',
        }
      }
    },
    {
      headerName: 'Data de ativação',
      type: 'date',
      value: {
        first: {
          value: 'date_signed',
        }
      }
    },
    {
      headerName: 'Data final',
      type: 'date',
      value: {
        first: {
          value: 'date_end',
        }
      }
    },
    {
      headerName: 'Atualizada em:',
      type: 'date',
      value: {
        first: {
          value: 'updated_at',
        }
      }
    },
    {
      headerName: 'Usuário',
      type: 'default',
      value: {
        first: {
          value: 'username',
        }
      }
    },

  ]
  return (
    <div>
      <h4 style={{ marginTop: 10, marginLeft: 10 }}>Histórico da CPR</h4>
      <div  style={{
        marginBottom: 16
      }}>

        <CustomizedTables 
          data={[...cpr_history].reverse()}
          columns={COLUMNSTABLE}
        />

      </div>
    </div>
  )
}